import { memo, useEffect, useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, BoxProps, Toolbar } from '@mui/material';
// config
import { HEADER } from '../../../config-global';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import navConfig from './config-navigation';

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();
  const [navConfig1,setNavConfig] = useState<any>([])
  
  useEffect(()=>{
    const navList = [...navConfig];
    function deepClone(obj:any) {
      if(typeof obj !=="object" || obj == null){
          return obj 
      }
      let res 
      if(obj instanceof Array){
          res = []
      }else{
          res = {}
      }

      for( var key in obj){
          if(obj.hasOwnProperty(key)){
            //@ts-ignore
              res[key] = deepClone(obj[key])
          }
      }
      return res
  }
    var arr: any = localStorage.getItem('menu')
    var arr1:any =deepClone(navList)
    console.log(arr1)
    if (arr) {
      var arr2: any = []
      arr = JSON.parse(arr)
      arr.forEach((v: any) => {
        v.sub_modules.forEach((value: any) => {
          arr2.push(value.name)
        })
        arr1[0].items.forEach((val: any) => {
          if (v.name === val.title || val.title=="首页") {
            val.stu = true
          }
        })
      })
      arr1[0].items.forEach((val: any) => {
        if (val.stu&&val.title!="首页") {
          val.children = val.children.filter((value: any, idx: number) => {
            return arr2.indexOf(value.title) != -1
          })
        }
      })
      arr1[0].items = arr1[0].items.filter((v: any) => v.stu === true)
      console.log('navConfig123',arr1)
      setNavConfig(arr1)
    }else{
      console.log('navConfig',navConfig)
      setNavConfig(navConfig)
    }
  },[])
  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: 0,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal data={navConfig1} />
      </Toolbar>

      <Shadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
